'use client'

import { motion } from 'framer-motion'
import { GeometricBackground } from '@/components/ui/geometric-background'
import { MarketingNavbar } from '@/components/layout/marketing-navbar'
import { MarketingFooter } from '@/components/layout/marketing-footer'
import Link from 'next/link'
import { Home, Mail, ArrowRight } from 'lucide-react'

export default function ContactClient() {
    return (
        <div className="relative min-h-screen bg-black text-white selection:bg-primary/30 overflow-x-hidden flex flex-col">
            <GeometricBackground />

            <MarketingNavbar />

            <main className="relative z-10 flex-grow flex items-center justify-center pt-32 pb-24 px-6 text-center">
                <div className="max-w-2xl mx-auto">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold tracking-tighter text-white mb-6">
                            GET IN<br />
                            <span className="text-primary">TOUCH.</span>
                        </h1>
                        <p className="text-lg sm:text-xl text-white/50 font-light leading-relaxed mb-12">
                            Have questions or need assistance? Our support team is here to help you make an impact.
                        </p>

                        <div className="inline-flex items-start gap-4 p-6 sm:p-8 rounded-3xl bg-white/[0.03] border border-white/[0.08] hover:bg-white/[0.06] hover:border-white/20 transition-all group">
                            <div className="w-12 h-12 rounded-2xl bg-primary/20 flex items-center justify-center text-primary group-hover:scale-110 transition-transform">
                                <Mail className="w-6 h-6" />
                            </div>
                            <div className="text-left">
                                <h3 className="text-white font-semibold text-lg">Email Support</h3>
                                <p className="text-white/40 mb-2">Typically responds within 24 hours</p>
                                <a
                                    id="contact-support-email-link"
                                    href="mailto:support@Lenklyst.com"
                                    className="text-primary hover:text-primary/80 font-bold flex items-center gap-2 group/link"
                                >
                                    support@Lenklyst.com
                                    <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" />
                                </a>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </main>

            <MarketingFooter />
        </div>
    )
}
